import React from "react"
import { useStaticQuery, graphql, Link } from "gatsby"
import SocialMedia from "./social-media"

const Footer = () => {
  const { allStrapiFooter } = useStaticQuery(graphql`
    query {
      allStrapiFooter {
        nodes {
          #image {
          #  alternativeText
          #  localFile {
          #    childImageSharp {
          #       gatsbyImageData(
          #         formats: AUTO
          #         layout: CONSTRAINED
          #         placeholder: BLURRED
          #       )
          #     }
          #  }
          #}
          description
          copyRight
          reserved
          designedBy
          socialMeadiaLink {
            name
            icon
            url
            style
          }
          sections {
            label
          }
          body {
            sections {
              label
              links {
                name
                url
              }
            }
          }
        }
      }
    }
  `)

  const footerContent = allStrapiFooter.nodes
  const body = footerContent[0].body
  const socialMediaLinks = allStrapiFooter.nodes[0].socialMeadiaLink
  //const image = allStrapiFooter.nodes[0].image

  const sections = body.map(section => {
    //console.log("sections: ", section)
    return section
  })

  const activeStyles = {
    //color: "#D0D9CD",
    fontWeight: 600,
    //borderBottom: "2px solid #CAF0F8",
    
    background: "linear-gradient(0.25turn, #5cdbf5, 40%, #CAF0F8)",

    backgroundClip: "text",
    WebkitBackgroundClip: "text",
    MozBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    MozTextFillColor: "transparent",
    display: "inline-block",
  }

  // const links = sections[0].sections.map(link => {
  //   //console.log("Link: ", link)
  //   return link
  // })
  //console.log("Links: ", links)
  //console.log("Footer Content - Nodes: ", allStrapiFooter)
  //console.log("Footer Content - Body: ", body)
  //console.log("Footer Content - Image: ", image)
  //console.log("Footer Content - Sections: ", sections)
  //console.log("Footer Content - socialMeadiaLink: ", socialMediaLinks)

  const currentYear = new Date().getFullYear()

  return (
    <footer className="uk-section uk-section-secondary uk-padding-remove" style={{ backgroundColor: "#0077B6"}}>
      <div className="uk-container uk-margin-medium-top uk-margin-medium-bottom">
        <div className="uk-grid uk-grid-medium" uk-grid="true">
          <div className="uk-width-2-5@m">
            <div className="uk-animation-fade uk-animation-slide-right-medium">
              <h4
                className="blue-grad uk-margin-remove-top uk-margin-right"
                style={{ fontWeight: "700" }}
              >
                <span>Professional Development Solutions</span>
              </h4>                  
            </div>
            <div
              className="uk-margin-bottom uk-margin-small-top"
              style={{
                color: "#FFFFFF",
              }}
            >
              {footerContent[0].description} {/* <span>THANK YOU</span> */}
            </div>
            <div className="uk-flex uk-flex-middle uk-flex-wrap uk-margin">
            <div className="">
              <h4
                className="blue-grad uk-margin-right"
                style={{ fontWeight: "700" }}
              >
                Let's Connect
              </h4>
            </div>
              
              <SocialMedia socialMediaLinks={socialMediaLinks} />
              {/* <AdminLinks /> */}
            </div>
          </div>

          {sections.map((section, index) => {
            //console.log("Section: ", section.sections[0])
            return (
              <div key={index} className="uk-width-expand@m uk-margin-small-left">
                <h5
                  className="blue-grad uk-margin-remove"
                  style={{ fontWeight: "700" }}
                >
                  {section.sections[0].label}
                </h5>
                {section.sections.map((section, index) => {
                  //console.log("Section: ", section.links)

                  return (
                    <ul key={index} className="uk-list ">
                      {section.links.map((link, index) => {
                        //console.log("Links: ", link)
                        return (
                          <li key={index}>
                            <Link
                              to={link.url}
                              alt={link.name}
                              className="hover-underline-animation"
                              style={{
                                //textDecoration: "none",
                                color: "#FFFFFF",
                                //fontWeight: "600"
                              }}
                              activeStyle={activeStyles}
                            >
                              <span>{link.name}</span>
                              
                            </Link>
                          </li>
                        )
                      })}
                    </ul>
                  )
                })}
              </div>
            )
          })}
        </div>

        <div className="uk-flex uk-flex-between uk-flex-wrap">
          <div className="uk-margin-top uk-margin-bottom">
          <h5
            className="blue-grad"
            style={{ fontWeight: "700" }}
          >
            <span>
              {footerContent[0].copyRight} {currentYear}{" "}
              {footerContent[0].reserved}
            </span>
          </h5>
            
          </div>

          <div className="uk-margin-top uk-margin-bottom">
            <a
              className="adu-footer-link gradient-text-footer2"
              href="https://adudev.co.uk"
              target="_blank rel=”noopener”"
            >
              <h5
            className="blue-grad"
            style={{ fontWeight: "700" }}
          >
            <span>
              {footerContent[0].designedBy}
            </span>
          </h5>
             
            </a>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
